/**
 * 
 * 整单赠送
 * 单品金额
 * 单品打折
 * 自由项
 * 批号
 */

export default [{
	"ID": 1,
	"Name": "VoucherDate",
	"Title": "修改日期",
	"TabIndex": 1,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 3,
	"Name": "WipeChange",
	"Title": "抹零",
	"TabIndex": 3,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 4,
	"Name": "GetGuide",
	"Title": "选导购",
	"TabIndex": 4,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 5,
	"Name": "TotalPresent",
	"Title": "整单赠送",
	"TabIndex": 5,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 7,
	"Name": "TotalSale",
	"Title": "整单打折",
	"TabIndex": 7,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 8,
	"Name": "SingleSale",
	"Title": "单品打折",
	"TabIndex": 8,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 9,
	"Name": "SingleAmount",
	"Title": "单品金额",
	"TabIndex": 9,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 10,
	"Name": "SingleMemo",
	"Title": "商品备注",
	"TabIndex": 10,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 11,
	"Name": "NewRetailOrder",
	"Title": "重新开单",
	"TabIndex": 11,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 12,
	"Name": "Unit",
	"Title": "修改单位",
	"TabIndex": 12,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 13,
	"Name": "Quantity2",
	"Title": "修改数量2",
	"TabIndex": 13,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 14,
	"Name": "FreeItem",
	"Title": "自由项",
	"TabIndex": 14,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 15,
	"Name": "Batch",
	"Title": "批号",
	"TabIndex": 15,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
},{
	"ID": 16,
	"Name": "Weigh",
	"Title": "称重",
	"TabIndex": 16,
	"Position": "Bottom",
	"ParentID": null,
	"IsEnd": 1,
	"SubOperations": null
}]
